module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    style: (_vm.styles.headerTable)
  }, _vm._l((_vm.data), function(record) {
    return _c('tr', {
      style: (_vm.styles.trStyle)
    }, [(record.parent) ? _c('th', {
      class: _vm.styles.headerTableTdClasses.primaryGreenBg,
      style: (_vm.styles.thStyle),
      attrs: {
        "rowspan": record.parent_span
      }
    }, [_vm._v("\n    " + _vm._s(record.parent) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('th', {
      class: _vm.styles.headerTableTdClasses.darkGreenBg,
      style: (_vm.styles.thStyle)
    }, [_vm._v("\n    " + _vm._s(record.name) + "\n    ")])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-196e33c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/flexTables/VerticalHeaderTable.vue
// module id = 357
// module chunks = 2